'use client';
import Hyperlink from '@/components/ui/hyperlink';
import Image from 'next/image';

const AboutArea = () => {
    return (
        <>
            <section className="desilo-about2-section bg-color-white section-padding-top overflow-hidden">
                <div className="container custom-container">
                    <div className="row align-items-stretch">
                        <div className="col-xl-6">
                            <div className="desilo-about2__thumb overflow-hidden pe-xl-4 h-100">
                                <Image
                                    height={0}
                                    width={0}
                                    sizes="100vw"
                                    src="/images/hero/about-hero.webp"
                                    alt="Desilo team is brainstorming and mapping business strategies to build impactful products."
                                    className="w-100 h-100 object-fit-cover"
                                />
                            </div>
                        </div>
                        <div className="col-xl-6 gsap-scroll row-margin-top2">
                            <div className="desilo-about2__content ps-xl-4">
                                <h2>
                                    We turn vision into impactful products
                                </h2>
                                <p className="mt-3 mt-lg-4">
                                    We don’t just build products; we build systems designed for compounding growth. Our integrated approach blends consulting, product design, and engineering to create platforms that
                                </p>
                                <div className="border-bottom-text">
                                    <p>
                                        Activate & Retain
                                    </p>
                                    <p>Clean UX, community loops, and subscriber funnels keep users engaged.</p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Monetize predictably
                                    </p>
                                    <p>Subscriptions, paywalls, and LTV analytics drive sustainable revenue.</p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Scale safely
                                    </p>
                                    <p>Modern infrastructure, governance, and integrations ensure reliable growth.</p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Apply AI where it matters
                                    </p>
                                    <p>Personalization, agents, and automation directly tied to your KPIs.</p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Prove ROI from day one
                                    </p>
                                    <p>Robust instrumentation and cohort views for clear business results.</p>
                                </div>
                                <Hyperlink className="mt-4 mt-lg-5" href="/about">
                                    More about us
                                </Hyperlink>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AboutArea;
